import styles from './styles.module.scss';

export const MenuButton = ({sidebarOpen, setSidebarOpen}) => {
    return (
        <button
            className={styles.menuButton}
            onClick={() => setSidebarOpen(!sidebarOpen)}
        >
            {sidebarOpen ? 
                <>✕</> 
                :
                <>
                    <span className={styles.line}/>
                    <span className={styles.line}/>
                    <span className={styles.line}/>
                </>
            }
        </button>
    );
};